import { ComparePage } from "./ComparePage";

export function FrameworkrxpAlternative() {
  return (
    <ComparePage
      competitor="FrameworkRxP"
      path="/compare/frameworkrxp-alternative"
      title="FrameworkRxP Alternative | WeConsult Rx"
      description="A FrameworkRxP alternative for chart-review automation: chart ingest, ASCP/Beers/STOPP rules and AI flags, prescriber and DON e-sign, and QuickBooks Online invoicing — one platform."
      h1="A FrameworkRxP alternative for chart-review automation."
    />
  );
}
